import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { FeatureFlagsService } from '@core/services/features/feature-flags.service';

/**
 * *appHasFeature="'nazwa'" — element jest w DOM tylko gdy flaga włączona.
 *
 * Subskrybuje strumień flag, bo w macierzy flagi dochodzą ASYNCHRONICZNIE po hydratacji
 * (SSR nie pobiera flag — brak TransferState). Na pierwszym renderze flaga = wyłączona,
 * element pojawia się dopiero gdy strumień dostarczy wartości.
 */
@Directive({
  selector: '[appHasFeature]',
  standalone: true,
})
export class HasFeatureDirective implements OnInit, OnDestroy {
  private featureName = '';
  private rendered = false;
  private subscription?: Subscription;

  @Input() set appHasFeature(name: string) {
    this.featureName = name;
    this.apply();
  }

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<unknown>,
    private featureFlagsService: FeatureFlagsService,
  ) {
  }

  ngOnInit(): void {
    this.subscription = this.featureFlagsService.flags$.subscribe(() => this.apply());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private apply(): void {
    const shouldRender = this.featureFlagsService.isEnabled(this.featureName);
    if (shouldRender && !this.rendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.rendered = true;
    } else if (!shouldRender && this.rendered) {
      this.viewContainerRef.clear();
      this.rendered = false;
    }
  }
}
